import { Injectable } from '@angular/core';
import { NotificationService, ModalService } from 'beyond-util';
import { RasporedEmitovanja } from '../models/raspored-emitovanja';
import * as moment from 'moment';

@Injectable()
export class RasporedService {
  private _raspored: RasporedEmitovanja;
  private emisijaVremeEmitovanja: any;

  private setRasporedData(emisija): void {
    this._raspored = new RasporedEmitovanja(
      emisija.DatumPocetkaEmitovanja,
      emisija.DatumZavrsetkaEmitovanja,
      emisija.UcestalostId,
      emisija.OsnovnaCenaSek,
      emisija.OsnovnaCenaCPP,
      emisija.Trajanje,
      0,
      emisija.ProgramId,
      emisija.ProgramNaziv
    );

    this.emisijaVremeEmitovanja = emisija.VremeEmitovanja;
  }

  public createNewRaspored(emisija) {
    this.setRasporedData(emisija);
    this.createRasporedBasedOnTerminiEmitovanja();
  }

  private createRasporedBasedOnTerminiEmitovanja() {
    if (this._raspored.UcestalostId === 1) {
      const termin = {
        Trajanje: this._raspored.Trajanje,
        OsnovnaCenaCPP: this._raspored.OsnovnaCenaCPP,
        OsnovnaCenaSek: this._raspored.OsnovnaCenaSek,
        VremeEmitovanja: this.emisijaVremeEmitovanja,
        DatumEmitovanja: this._raspored.DatumPocetkaEmitovanja,
        Zauzeto: this._raspored.Zauzeto,
        Preostalo: this._raspored.Preostalo,
        ProgramId: this._raspored.ProgramId,
        ProgramNaziv: this._raspored.ProgramNaziv,
      };

      this._raspored.Raspored.push(termin);
    }

    if (this._raspored.UcestalostId > 1) {
      const arrayOfDates = this.getArrayOfDatesBasedOnUcestalostEmitovanja();
      arrayOfDates.forEach(date => {
        const t = {
          Trajanje: this._raspored.Trajanje,
          OsnovnaCenaCPP: this._raspored.OsnovnaCenaCPP,
          OsnovnaCenaSek: this._raspored.OsnovnaCenaSek,
          VremeEmitovanja: this.emisijaVremeEmitovanja,
          DatumEmitovanja: date,
          Zauzeto: this._raspored.Zauzeto,
          Preostalo: this._raspored.Preostalo,
          ProgramId: this._raspored.ProgramId,
          ProgramNaziv: this._raspored.ProgramNaziv,
        };

        this._raspored.Raspored.push(t);
      });
    }
  }

  getRaspored() {
    return this._raspored.Raspored;
  }

  getArrayOfDatesBasedOnUcestalostEmitovanja(): Array<any> {
    const start = this.stripHoursMinutesSeconds(
      this._raspored.DatumPocetkaEmitovanja
    );
    const end = this.stripHoursMinutesSeconds(
      this._raspored.DatumZavrsetkaEmitovanja
    );

    switch (this._raspored.UcestalostId) {
      case 2:
        return this.getRangeOfDates(start, end, 'days');
      case 3: // Nedeljno
        return this.getRangeOfDates(start, end, 'weeks');
      case 4: // Mesecno
        return this.getRangeOfDates(start, end, 'months');
      case 5: // Radnim danima
        const allDatesRD = this.getRangeOfDates(start, end, 'days');
        const weekdays = allDatesRD.filter(
          d => moment(d).weekday() > 0 && moment(d).weekday() < 6
        );

        return weekdays;
      case 6: // Samo vikendima.
        const allDatesND = this.getRangeOfDates(start, end, 'days');
        const weekend = allDatesND.filter(
          d => moment(d).weekday() === 6 || moment(d).weekday() === 0
        );

        return weekend;
    }
  }

  stripHoursMinutesSeconds(date) {
    return moment(date).format('YYYY-MM-DD');
  }

  public getRangeOfDates(start, end, key) {
    const now = moment(start);
    const dates = [];

    while (now.isSameOrBefore(end)) {
      dates.push(now.format('YYYY-MM-DD'));
      now.add(1, key);
    }

    return dates;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/raspored.service.ts